<template>
  <v-menu v-model="open" :close-on-content-click="false" location="bottom start" @click.stop>
    <template #activator="{ props: menuProps }">
      <slot name="activator" :props="menuProps" />
    </template>
    <v-card class="tag-due-menu" @click.stop>
      <v-date-picker
        :model-value="isoToLocalDate(dueDate)"
        hide-header
        show-adjacent-months
        @update:model-value="onPick" />
      <div class="tag-due-menu__actions">
        <span class="tag-due-menu__hint">Due date for {{ label }}</span>
        <button v-if="dueDate" type="button" class="tag-due-menu__clear" @click.stop="onPick(null)">Clear</button>
      </div>
    </v-card>
  </v-menu>
</template>

<script setup>
import { ref } from "vue";
import { isoToLocalDate, localDateToIso } from "@/utils/dateUtils";

defineProps({
  dueDate: { type: [String, null], default: null },
  label: { type: String, default: "" },
});

const emit = defineEmits(["update:dueDate"]);

const open = ref(false);

function onPick(date) {
  open.value = false;
  emit("update:dueDate", date ? localDateToIso(date) : null);
}
</script>

<style lang="scss" scoped>
.tag-due-menu {
  border-radius: 12px !important;
}

.tag-due-menu__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 16px 12px;
}

.tag-due-menu__hint {
  font-family: $lh_font_family_dm_sans;
  font-size: 12px;
  color: $lh_color_blue_gray;
}

.tag-due-menu__clear {
  background: none;
  border: none;
  padding: 2px 4px;
  color: $lh_color_blue;
  font-family: $lh_font_family_dm_sans;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}
</style>
